import { gql } from '@apollo/client';
import { useFarmColumns } from '../utils/columns';
import FarmsView from './FarmsView';
import { FarmColumnsFragment } from '../constants/fragments';

const SharedProjectsQuery = gql`
  ${FarmColumnsFragment}
  query SharedProjects {
    sharedFarms {
      ...FarmColumnFields
    }
  }
`;

const SharedProjectsView = () => {
  const { farmColumns } = useFarmColumns(SharedProjectsQuery);
  return (
    <FarmsView
      header="Shared with Me"
      searchPlaceholder="Search shared projects by name or team"
      query={SharedProjectsQuery}
      cols={farmColumns}
      sortColumn="objectUpdatedAt"
      sortDirection="desc"
    />
  );
};

export default SharedProjectsView;
